import React from "react";
import { X } from "lucide-react";
import styles from "../SeriesView.module.css";

const DeleteChapterDialog = ({ isOpen, onClose, onConfirm, chapterTitle, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.midScreenOverlay}>
      <div className={styles.midoverlayContent} style={{ maxWidth: "500px" }}>
        <div className={styles.overlayHeader}>
          <h2>Delete Chapter</h2>
          <button onClick={onClose} className={styles.closeButton} disabled={isLoading}>
            <X size={24} />
          </button>
        </div>
        <div className={styles.overlayBody}>
          <p className={styles.confirmationText}>
            Are you sure you want to delete "{chapterTitle}"? This action cannot be undone.
          </p>
          <div className={styles.confirmationActions}>
            <button 
              className={`${styles.actionButton} ${styles.cancelButton}`} 
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button 
              className={`${styles.actionButton} ${styles.deleteButton}`} 
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteChapterDialog;